/** Admin CMS — editorial status ↔ public visibility helpers. */

export function slugifyTitle(text) {
	return String(text || '')
		.toLowerCase()
		.replace(/['']/g, '')
		.replace(/&/g, 'and')
		.replace(/[^a-z0-9]+/g, '-')
		.replace(/^-+|-+$/g, '');
}

export function isCmsPublished(form) {
	return form?.editorial_status === 'published' || !!form?.published;
}

/** Keep `published` boolean aligned with editorial status before API save. */
export function prepareCmsPayload(form) {
	const editorial_status = form.editorial_status || 'draft';
	return {
		...form,
		editorial_status,
		published: editorial_status === 'published',
	};
}

export function getPublicSiteUrl(path = '') {
	const base = (
		process.env.REACT_APP_SITE_URL
		|| (typeof window !== 'undefined' ? window.location.origin : 'https://visitallnepal.com')
	).replace(/\/$/, '');
	if (!path) return base;
	return `${base}${path.startsWith('/') ? path : `/${path}`}`;
}

export function validateGuideForPublish(form) {
	const missing = [];
	if (!form.title?.trim()) missing.push('title');
	if (!form.slug?.trim()) missing.push('slug');
	if (!form.category) missing.push('category');
	if (!form.summary?.trim()) missing.push('summary');
	if (!form.body?.trim()) missing.push('body');
	return missing;
}

/** Map API record → admin form (fixes missing editorial_status on older API responses). */
export function normalizeCmsFormData(data, defaults = {}) {
	if (!data) return { ...defaults };
	const editorial_status = data.editorial_status || (data.published ? 'published' : 'draft');
	return {
		...defaults,
		...data,
		editorial_status,
		published: editorial_status === 'published',
	};
}
